import { createReducer, on } from '@ngrx/store';
import * as fromOptimizely from '../actions/optimizely.action';
import { StateSlice } from '@core/helpers/state-slice';

export type OptimizelyState = StateSlice<boolean>;

export const initialState: OptimizelyState = {
  data: false,
  loaded: false,
  loading: false,
  error: null,
};

const optimizelyReducer = createReducer(
  initialState,
  on(fromOptimizely.optimizelyLoaded, (state, { payload }) => {
    return {
      ...state,
      data: payload,
      loading: false,
      loaded: true,
    };
  })
);

export function reducer(
  state: OptimizelyState | undefined,
  action: fromOptimizely.OptimizelyActions
) {
  return optimizelyReducer(state, action);
}
